import { createRouteRef } from '@backstage/core-plugin-api';

export const complianceRouteRef = createRouteRef({
  id: 'compliance',
});